<template>
  <b-modal
    id="confirm-delete-modals"
    title="Block Device"
    size="lg"
    @ok="blockDevice"
  >
    <p>Are you sure you want to block this device?</p>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
  components: { BModal },
  props: {
    data: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const blockDevice = async () => {
      try {
        const body = {
          id: props.data.user_id,
          deviceId: props.data.device_id,
        }
        await ctx.root.$store.dispatch('users/blockDevice', body)
        ctx.emit('Blocked')
      } catch (error) {
        console.log(error.response)
      }
    }
    return {
      blockDevice,
    }
  },
}
</script>
